export default __webpack_public_path__ + "static/media/3.dc9d2480.png";